// extracted by mini-css-extract-plugin
export default {"container":"ApplicationDescription_container__al5-Q"};